/**
 * useLatentCollection
 * Fetches defaulted/latent credits portfolio from credit-worker backoffice API
 */

import { useQuery } from '@tanstack/react-query';
import { getDefaultedCredits } from '@/services/credit-worker.service';

const REFETCH_INTERVAL = 60_000;

export function useLatentCollection() {
  const query = useQuery({
    queryKey: ['collection', 'latent', 'defaulted'],
    queryFn: () => getDefaultedCredits(),
    refetchInterval: REFETCH_INTERVAL,
  });

  return {
    portfolio: query.data?.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
